// @ts-ignore
import Feedback from 'feeder-react-feedback' // import Feedback component
import 'feeder-react-feedback/dist/feeder-react-feedback.css' // import stylesheet
import React from 'react'
import queryString from 'query-string'
import { QueryContext } from '../../contexts/queryContext'
import DebugInfo from '../DebugInfo/DebugInfo'
import { useIsMobile } from '../../utils/hooks'

type ButtonContainerProps = {
  leftButton?: JSX.Element
  centerButton?: JSX.Element
  rightButton?: JSX.Element
  hideFeedback?: boolean
}

const BottomContainer: React.FC<ButtonContainerProps> = ({
  leftButton,
  centerButton,
  rightButton,
  hideFeedback,
}) => {
  const [query] = React.useContext(QueryContext) //now receiving as string
  const query_dict = queryString.parse(query)
  const isMobile = useIsMobile()

  return (
    <div className='Bottom-container'>
      {query_dict.debug === 'true' ? <DebugInfo /> : null}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <div
          className='Bottom-subcontainer'
          style={{ justifyContent: 'flex-start' }}>
          {leftButton || <br />}
        </div>

        <div
          className='Bottom-subcontainer'
          style={{ justifyContent: 'center' }}>
          {centerButton || <br />}
        </div>

        <div
          className='Bottom-subcontainer'
          style={{ justifyContent: 'flex-end' }}>
          {rightButton || <br />}
        </div>
        {hideFeedback || isMobile ? null : (
          <Feedback
            email={true}
            projectId='5fb7c86227108a0004314101'
            primaryColor='#d9559d'
            hoverBorderColor='#303133'
          />
        )}
      </div>
    </div>
  )
}

export default BottomContainer
